module.exports = __webpack_public_path__ + "assets/img/SAI-block-329.4b1dd226.png";